import React from 'react'
import { Button, Table } from 'react-bootstrap'
import { Edit, Trash } from 'react-feather'

const VehicleList = ({ vehicleData, handleEdit, handleDelete,vendors }) => {

    const getVendorName = (vendor_id) => {
        const vendor = vendors.find((d)=>d.id === vendor_id)
        return vendor ? vendor.name : vendor_id;
    }
    return (
        <>
            <Table>
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Vendor Name</th>
                        <th>Vehicle</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {vehicleData.map((data,index) => (
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td style={{textTransform:'capitalize'}}>{getVendorName(data.vendor_id)}</td>
                            <td>{data.vehicle_number}</td>
                             <td>
                                <div className="d-flex gap-2">
                                    <Button variant='warning' size='sm' onClick={() => handleEdit(data)}><Edit size={14} /></Button>
                                    {/* <Button variant='danger' size='sm' onClick={() => handleDelete(index)}><Trash size={14} /></Button> */}
                                </div>

                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    )
}

export default VehicleList
